module.exports = __webpack_public_path__ + "img/search.37564b0a.svg";